module.exports = __webpack_public_path__ + "static/media/page07_man_woman.4e6917ed.png";